import { render } from "./NewRewardPopup.vue?vue&type=template&id=591aa927"
import script from "./NewRewardPopup.vue?vue&type=script&lang=js"
export * from "./NewRewardPopup.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__